import script from "./MyServices.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyServices.vue?vue&type=script&setup=true&lang=ts"

import "./MyServices.vue?vue&type=style&index=0&id=4bbf5edf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bbf5edf"]])

export default __exports__